import _request from "../../_request";

const getPartnerShipmentStatusOrders = (ISO, signature) => {
  const config = {
    url: `/shipment-status/partner/${signature}`,
    ISO,
  };
  return _request(config);
};

const getPartnerCurrentLocation = (ISO, data) => {
  const config = {
    url: `/current-location?type=partner&signature=${data.signature}&lat=${data.lat}&lng=${data.lng}`,
    ISO,
  };
  return _request(config);
};

const partnerShipmentStatusService = {
  getPartnerShipmentStatusOrders,
  getPartnerCurrentLocation,
};

export default partnerShipmentStatusService;
